<template>
  <div class="loginform">
    <img src="./assets/img/logo.jpg" alt="" class="logo">
    <div class="box">
      <div class="tit">登录</div>
      <div class="app-weui-cells weui-cells weui-cells_form">
        <div class="weui-cell">
          <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
          <div class="weui-cell__bd">
            <input v-model="tel" class="weui-input" type="tel" placeholder="请输入您的手机号" />
          </div>
        </div>
        <!-- <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
                <div class="weui-cell__bd"><input v-model="account" class="weui-input" type="tel" placeholder="请输入手机号"></div>
            </div>
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">密码</label></div>
                <div class="weui-cell__bd"><input v-model="password" class="weui-input" type="password" placeholder="请输入密码"></div>
            </div>
            <div class="weui-cell weui-cell_vcode">
                <div class="weui-cell__hd"><label class="weui-label">图形验证码</label></div>
                <div class="weui-cell__bd">
                    <input v-model="captcha" class="weui-input" type="text" placeholder="请输入图形验证码"/>
                </div>
                <img v-if="captcha_info.captcha_url" @click="getcaptcha()" v-bind:src="publics.HOST+captcha_info.captcha_url" alt="" class="imgyzm">
            </div> -->

        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__hd">
            <label class="weui-label">验证码</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="sms_value" class="weui-input" type="tel" maxlength="6" placeholder="请输入短信验证码" />
          </div>
          <div class="weui-cell__ft">
            <button @click="send()" v-bind:disabled="disabled" class="weui-vcode-btn">{{time}}</button>
          </div>
        </div>
        <!-- <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label">邀请码</label></div>
                <div class="weui-cell__bd">
                    <input v-model="code" class="weui-input" type="text" placeholder="选填"/>
                </div>
            </div> -->
      </div>
    </div>

    <div class="other">
      <router-link :to="{ name: 'register',query:{code:code} }" class="fl">新用户注册</router-link>
    </div>

    <div class="app-btn-area weui-btn-area">
      <button @click="submit()" v-bind:disabled="subdisabled" class="weui-btn" :class="[subdisabled?'disabled':'']">登录</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      time: '获取验证码',
      currentTime: 60, // 发送验证码倒计时
      disabled: false, // 发送验证码按钮状态
      tel: "",
      sms_value: '',

      captcha_info: '',
      account: '',
      password: '',
      captcha: '',

      code: this.$route.query.code,
    }
  },
  computed: {
    subdisabled() {
      return !(this.tel && this.sms_value)
    }
  },
  mounted() {

  },
  methods: {
    send() {
      let vm = this;
      if (!/^1[2-9]\d{9}$/.test(vm.tel)) {
        vm.publics.message.danger('请输入正确的手机号码');
        return false;
      }
      // 0 注册  3 登录
      vm.ajax("sms", "post", {
        tel: vm.tel,
        sms_type: 3
      }, e => {
        //test
        vm.publics.message.success(e.msg);
        //test
      })
      vm.countdown();
    },
    countdown() {
      let vm = this;
      vm.disabled = true;
      let currentTime = vm.currentTime
      currentTime--;
      vm.time = currentTime + '秒后重发'
      if (currentTime <= 0) {
        vm.time = '重新发送';
        vm.currentTime = 61;
        vm.disabled = false;
        // vm.getcaptcha();
      } else {
        vm.currentTime = currentTime;
        setTimeout(function () {
          vm.countdown()
        }, 1000)
      }
    },
    // 282129
    submit() {
      var vm = this;
      if (!/^1[2-9]\d{9}$/.test(vm.tel)) {
        vm.publics.message.danger('请输入正确的手机号码');
        return false;
      }
      if (!vm.sms_value) {
        vm.publics.message.danger('请输入手机验证码');
        return false;
      }
      vm.ajax("login", "post", {
        tel: vm.tel,
        sms_type: 3,
        sms_value: vm.sms_value,
      }, e => {
        if (e.code == "1000") {
          // setTimeout(function(){
          ISLOGIN = true;
          vm.$parent.islogin = true;
          vm.$router.replace('/')
          // },1000)
        } else {

        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/login.vue